export const consultingFAQData = [
  {
    question: "Was unterscheidet Executive Coaching von klassischem Führungstraining?",
    answer: "Executive Coaching ist individuell auf Sie zugeschnitten und fokussiert sich auf Ihre persönliche Führungsexzellenz. Anstatt standardisierter Methoden entwickeln wir gemeinsam Ihren authentischen Führungsstil."
  },
  {
    question: "Für welche Führungsebenen ist das Coaching geeignet?",
    answer: "Mein Coaching richtet sich an Führungskräfte aller Ebenen - von Teamleitern bis hin zu C-Level Executives. Entscheidend ist der Wunsch nach persönlicher Weiterentwicklung und Führungsexzellenz."
  },
  {
    question: "Wie lange dauert ein Executive Coaching?",
    answer: "Die Dauer variiert je nach Zielsetzung. Typischerweise umfasst ein Coaching 6-12 Sitzungen über 3-6 Monate. Im Erstgespräch definieren wir gemeinsam den optimalen Rahmen für Ihre Ziele."
  },
  {
    question: "Kann das Coaching auch in der Natur stattfinden?",
    answer: "Ja, ich biete Walk & Talk Coaching in inspirierenden Naturumgebungen an. Am Rothsee im Fränkischen Seenland für regelmäßige Sessions oder in den Alpen - besonders in der Region Garmisch-Partenkirchen am wunderschönen Eibsee - als exklusive, individuelle Vereinbarung. Perfekt, um Ihren Urlaub mit strategischer Führungsreflexion zu verbinden."
  },
  {
    question: "Wie wird Vertraulichkeit sichergestellt?",
    answer: "Absolute Vertraulichkeit ist die Basis meiner Arbeit. Alle Coaching-Inhalte unterliegen der Schweigepflicht. Bei Unternehmens-Coachings werden Rahmen und Berichtswege vorab transparent vereinbart."
  }
];